import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { SelectBankAccountComponent } from './select-bank-account.component';
import { SharedModule } from '../shared.module';
import { CurrencyCountryPipeModule } from '@pipes/currency-country/currency-country.module';
import { MaskAccountNumberModule } from '@pipes/mask-account-number/mask-account-number.module';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';
import { InputSelectModule } from '../input-select/input-select.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterModule } from '@angular/router';
import { InputSearchModule } from '../input-search/input-search.module';

@NgModule({
  declarations: [SelectBankAccountComponent],
  imports: [
    SharedModule,
    MatSelectModule,
    FormsModule,
    RouterModule.forChild([]),
    CurrencyCountryPipeModule,
    MaskAccountNumberModule,
    CurrencyCountryPipeModule,
    MatListModule,
    MatRadioModule,
    ReactiveFormsModule,
    InputSelectModule,
    MatProgressSpinnerModule,
    InputSearchModule,
  ],
  exports: [SelectBankAccountComponent],
})
export class SelectBankAccountModule {}
